import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { StyledSelect } from 'lib/styles';

const Container = styled.div`
	padding: 40px 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

class Space extends React.Component {
	static propTypes = {
	  spaces: PropTypes.array,
	  space: PropTypes.string,
	  selectedSpace: PropTypes.string,
	  t: PropTypes.func,
	  updatePageSettingsHandler: PropTypes.func,
	}

	static defaultProps = {
	  space: '',
	}

	changeHandler = event => {
	  // This updates page text component in Editor.js
	  this.props.updatePageSettingsHandler({
	    space: event.target.value === '' ? null : event.target.value,
	  })
	}

	render() {
	  const { t, spaces } = this.props;
	  const options = spaces
	  // Sort by floor and size
	    .sort((a,b) => a.floor > b.floor ? 1 : a.floor < b.floor ? -1 : a.area > b.area ? 1 : a.area < b.area ? -1 : 0)
	    .reverse()
	    .map(space => ({
	      value: space.slug,
	      name: `${t('general/floor_abbr', { floor: space.floor })}, ${space.name}, ${space.area} m²`,
	      floor: space.floor,
	    }));
	  const allFloors = spaces.map(space => space.floor);
	  const floors = allFloors.filter((floor, i) => allFloors.findIndex(f => f === floor) === i);
	  const optionGroups = floors.map(floor => ({
	    name: t('general/floor', { floor }),
	    options: options.filter(option => option.floor === floor),
	  }));
	  const blank = [{
	    value: '',
	    name: t('brochure/Controls/Page/Not selected'),
	  }];

	  return (
	    <React.Fragment>
	      <Container>
	        <Label>{t('brochure/Controls/Page/Attached space')}</Label>
	        <StyledSelect
	          options={blank.concat(optionGroups)}
	          id="space-select"
	          value={this.props.space || ''}
	          onChange={event => this.changeHandler(event)}
	        />
	      </Container>
	    </React.Fragment>
	  )
	}
}

export default translate('translations')(Space)
